<template>
  <Layout>
    <div class="flex items-baseline">
      <h1 class="h1">Persoon toevoegen</h1>
    </div>
    <div class="my-8 lg:flex -mx-5">
      <div class="lg:w-2/3 mx-5">
        <PersonForm action="/json/people" @success="success" @cancel="$router.back()" isNew />
      </div>
    </div>
  </Layout>
</template>

<script>
import PersonForm from "@/components/PersonForm";

export default {
  components: {
    PersonForm
  },

  metaInfo() {
    return { title: "Persoon toevoegen" };
  },

  methods: {
    success() {
      this.$router.push({
        name: "people",
        query: this.$store.state.routes.people
      });
    }
  }
};
</script>
